"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var setFlagStatus = function (id, flagStatus) {
    return (0, service_1.getService)()
        .patch("/managed_campus/devices/".concat(id), flagStatus)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = setFlagStatus;
